import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { getCommentCount } from '@ifeng-fe/container_content/common/client/services/api';

class Recommend extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    state = {
        count: 0,
    };

    async componentDidMount() {
        const { content } = this.props;

        if (content && content.length > 0) {
            try {
                const { count } = await getCommentCount(content[0].commentUrl);

                this.setState({
                    count,
                });
            } catch (e) {
                console.error(e);
            }
        }
    }

    render() {
        const { count } = this.state;
        const { content } = this.props;

        if (!content || content.length === 0) return <div />;

        const main = content[0];

        return (
            <div className={styles.box}>
                <div className={styles.title}>
                    <h4>频道推荐</h4>
                    <span>
                        <a href="https://gongyi.ifeng.com/hot/special/fhwytjh/ " target="_blank">
                            <img
                                src="//p1.ifengimg.com/a/2017/0817/donate_4.jpg"
                                width="145"
                                height="20"
                                alt="凤凰网公益基金救助直达"
                            />
                        </a>
                    </span>
                </div>
                <div className={styles.list}>
                    <h2>
                        <a href={main.url} target="_blank" title={main.title}>
                            {main.title}
                        </a>
                    </h2>
                    <h4>
                        <span>
                            <a href={`//gentie.ifeng.com/c/comment/${main.base62Id}`} target="_blank">
                                <em>{count}</em>
                                <span>条评论</span>
                            </a>
                        </span>
                        {main.newsTime}
                    </h4>
                    <ul>
                        {content.slice(1).map((item, index) => (
                            <li key={index} className="clearfix">
                                <a href={item.url} target="_blank" title={item.title}>
                                    <p>{item.title}</p>
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        );
    }
}

export default errorBoundary(Recommend);
